import { useReducer } from "react";
import { ReactComponent as ToggleOff } from "../../../assets/toggleOff.svg";
import { ReactComponent as ToggleOn } from "../../../assets/toggleOn.svg";

export default function Toggle(props: {
  isOn?: boolean;
  onChange?: (e: boolean) => void;
}) {
  const [toggle, setToggle] = useReducer(
    (x: boolean) => !x,
    props.isOn ?? false
  );
  return (
    <>
      {!toggle && (
        <ToggleOff
          style={{ cursor: "pointer" }}
          onClick={() => {
            props.onChange?.(!toggle);
            setToggle();
          }}
        />
      )}
      {toggle && (
        <ToggleOn
          style={{ cursor: "pointer" }}
          onClick={() => {
            props.onChange?.(!toggle);
            setToggle();
          }}
        />
      )}
    </>
  );
}
